export default __webpack_public_path__ + "static/media/12.88df226b.png";